"use client";

import AuthForm from "./AuthForm";
import { useDialog } from "@/contexts/DialogContext";
import { useFavorites } from "@/contexts/FavoritesContext";

const AuthDialog = () => {
  const { closeDialog } = useDialog();
  const { favorites, clearFavorites } = useFavorites();

  return (
    <div className="w-full space-y-4 px-8 py-8 md:px-16">
      <AuthForm favorites={favorites} closeDialog={closeDialog} clearFavorites={clearFavorites} />
    </div>
  );
};

export default AuthDialog;
